import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import $user from "@/core/user/store";

const MIN_PASSWORD = 8;

const empty = { login: "", username: "", password: "", repeat: "" };

const RegisterDialog = ({ open, onClose, onCreated }) => {
  const [form, setForm] = React.useState(empty);
  const [loading, setLoading] = React.useState(false);

  const set = (field) => (event) =>
    setForm((prev) => ({
      ...prev,
      // Логин приводится к нижнему регистру прямо при вводе: сервер его всё
      // равно нормализует, а auth() ищет точным совпадением — записанный логин
      // должен совпадать с увиденным.
      [field]:
        field === "login" ? event.target.value.toLowerCase() : event.target.value,
    }));

  const mismatch = form.repeat.length > 0 && form.password !== form.repeat;
  const short = form.password.length > 0 && form.password.length < MIN_PASSWORD;

  const invalid =
    !form.login.trim() ||
    !form.username.trim() ||
    form.password.length < MIN_PASSWORD ||
    form.password !== form.repeat;

  const onSubmit = async () => {
    setLoading(true);
    try {
      // Ошибку сервера показывает интерсептор — локально её не дублируем.
      await $user.registerPersonal({
        login: form.login,
        username: form.username,
        password: form.password,
      });
      setForm(empty);
      onCreated();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Личный аккаунт</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body2" sx={{ mb: 2 }}>
          Аккаунт получит те же права, что у общего. После создания вы сразу
          продолжите работу под ним.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Логин"
          value={form.login}
          onChange={set("login")}
          helperText="Например, ivan@translator"
        />
        <TextField
          fullWidth
          margin="dense"
          label="Отображаемое имя"
          value={form.username}
          onChange={set("username")}
        />
        <TextField
          fullWidth
          margin="dense"
          type="password"
          label="Пароль"
          value={form.password}
          onChange={set("password")}
          error={short}
          helperText={short ? `Не короче ${MIN_PASSWORD} символов` : " "}
        />
        <TextField
          fullWidth
          margin="dense"
          type="password"
          label="Повтор пароля"
          value={form.repeat}
          onChange={set("repeat")}
          error={mismatch}
          helperText={mismatch ? "Пароли не совпадают" : " "}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" disabled={loading || invalid} onClick={onSubmit}>
          Создать
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegisterDialog;
